export class DiseaseMedical {
         diseaseMedicationId?: number;
         diseaseMedicationType: number;
         notifyTeacher: boolean = false;
         description: string;
         descriptionLatin: string;
       }
